import { c as _c } from "react/compiler-runtime";
import './accordion-main.scss';
import { AccordionGroup } from '@sola/ark-core/molecules/accordion-group/accordion-group.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { getPlaceholderItems } from '../../../utils/storybook.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export const AccordionMain: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(51);
  let alt;
  let items;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      seoLevel: t2,
      items: t3,
      alt: t4,
      media: _media,
      quotation: _quotation,
      ...t5
    } = t0;
    t1 = t2;
    items = t3;
    alt = t4;
    props = t5;
    $[0] = t0;
    $[1] = alt;
    $[2] = items;
    $[3] = props;
    $[4] = t1;
  } else {
    alt = $[1];
    items = $[2];
    props = $[3];
    t1 = $[4];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  let t2;
  if ($[5] !== items) {
    t2 = !items || items.length < 2 ? getPlaceholderItems(items, 2) : items;
    $[5] = items;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const accordionItems = t2;
  const hasHeaderContent = !!props.title || !!props.body;
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[7] !== alt || $[8] !== props || $[9] !== seoLevel) {
    const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
    t7 = "Accordion component";
    const t8 = !alt;
    if ($[16] !== alt || $[17] !== t8) {
      t6 = cn("container w-full flex flex-col gap-comfy-xl", {
        "Accordion--alt @md:flex-row": alt,
        "items-center @md:gap-roomy-xs  @lg:gap-roomy-sm": t8
      });
      $[16] = alt;
      $[17] = t8;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    const t9 = !alt;
    if ($[19] !== t9) {
      t5 = cn("Accordion__content w-full", {
        "mx-auto md:max-w-md": t9
      });
      $[19] = t9;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    T0 = FeatureBase;
    t3 = props;
    t4 = getBaseSizeProps(headerDisplayLevel);
    $[7] = alt;
    $[8] = props;
    $[9] = seoLevel;
    $[10] = T0;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    T0 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  const t8 = alt ? "standard" : "centered";
  let t9;
  if ($[21] !== T0 || $[22] !== seoLevel || $[23] !== t3 || $[24] !== t4 || $[25] !== t8) {
    t9 = <T0 {...t3} {...t4} seoLevel={seoLevel} variant={t8} inline={true} />;
    $[21] = T0;
    $[22] = seoLevel;
    $[23] = t3;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t5 || $[28] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== alt) {
    t11 = cn("w-full max-w-md", {
      "mx-auto": alt
    });
    $[30] = alt;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== accordionItems || $[33] !== hasHeaderContent || $[34] !== seoLevel) {
    let t13;
    if ($[36] !== hasHeaderContent || $[37] !== seoLevel) {
      t13 = t14 => {
        const {
          title,
          subtitle: _subtitle,
          quotation: _quotationitem,
          primaryCTA: _primaryCTA,
          secondaryCTA: _secondaryCTA,
          tertiaryCTA: _tertiaryCTA,
          media: _mediaItem,
          icon: _icon,
          ...item
        } = t14;
        return {
          header: title || "",
          seoLevel: hasHeaderContent ? seoLevel + 1 : seoLevel,
          children: <FeatureBase {...item} variant="standard" bodySize="sm" buttonSize="sm" inline={true} />
        };
      };
      $[36] = hasHeaderContent;
      $[37] = seoLevel;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    t12 = accordionItems.map(t13);
    $[32] = accordionItems;
    $[33] = hasHeaderContent;
    $[34] = seoLevel;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[39] !== t12) {
    t13 = <AccordionGroup items={t12} />;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t11 || $[42] !== t13) {
    t14 = <div className={t11}>{t13}</div>;
    $[41] = t11;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t10 || $[45] !== t14 || $[46] !== t6) {
    t15 = <div className={t6}>{t10}{t14}</div>;
    $[44] = t10;
    $[45] = t14;
    $[46] = t6;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t15 || $[49] !== t7) {
    t16 = <section className={t7}>{t15}</section>;
    $[48] = t15;
    $[49] = t7;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  return t16;
};